var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-shops-section-logo"},[(_vm.image && _vm.image.src)?_c(_setup.CdnImg,{attrs:{"src":_vm.image.src,"width":+(_vm.image.width ?? 495),"height":+(_vm.image.height ?? 158),"alt":_vm.image.alt}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }